import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../pages/PropertyDetails/propertydetails.css";
import Header from "../../components/Navbar";
import Map from "../../myimgs/Group 27.png";
import Home from "../../myimgs/home1.png";
import BAD from "../../myimgs/bads.png";
import BATH from "../../myimgs/bath.png";
import Size from "../../myimgs/size.png";
import pdf from "../../myimgs/pdf.png";
import Slider from "../../components/slider/slider";
import Footer from "../../components/footer/footer";
import nodata from "../../myimgs/Group 232.png";
import Swal from "sweetalert2";
import socketService from "../../utils/socket";
import Loader from "../../components/Loader/loader";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Lcoction from "../../myimgs/Group 28.png";
import ShareDialog from "../../components/ShareDialog";


function Mylistingview() {
  const hash = window.location.hash;
  const navigate = useNavigate();
  // const propertyId = hash ? hash.replace("#", "") : null;
  const propertyId = localStorage.getItem("selectedPropertyId");
  const userId = localStorage.getItem("userId");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [thumbImages, setThumbImages] = useState([]);

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      if (!propertyId) {
        setError("❌ Property ID not found in URL.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${baseUrl}/property/${propertyId}`);

        if (response.data.status === 200) {
          const data = response.data.data;
          setPropertyData(data);

          // Images
          if (data.propertyImages?.length > 0) {
            setMainImage(data.propertyImages[0].imageUrl);
            setThumbImages(data.propertyImages.slice(1));
          }
        } else {
          setError("Failed to fetch property details");
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching property data");
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
  }, [propertyId, userId, baseUrl]);

  const handleThumbClick = (clickedImage) => {
    if (!clickedImage || !mainImage) return;

    // Swap main and clicked image
    const updatedThumbs = thumbImages.map((img) =>
      img.imageUrl === clickedImage.imageUrl ? { imageUrl: mainImage } : img
    );
    setMainImage(clickedImage.imageUrl);
    setThumbImages(updatedThumbs);
  };

  if (loading)
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );

  if (error) return <div className="error">{error}</div>;
  if (!propertyData) return null;

  const {
    propertyName,
    propertyType,
    streetAddress,
    city,
    state,
    zipcode,
    country,
    propertySize,
    bedRooms,
    bathroms,
    halfBathrooms,
    marketingDescription,
    user,
    textDisclaimer,
    docDisclaimer,
    totalRooms,
  } = propertyData;
  // timersss  ...
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    // ✅ Format date as "DD-MM-YYYY, HH:MM"
    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      // ✅ Before auction starts
      if (now < startDate) {
        return (
          <>
            <span className="aucnt">Offer Starting Date</span> <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;

      // ✅ After Offer Ended
      if (diff <= 0) {
        return <span className="aucnt">Offer Ended</span>;
      }

      // ✅ While auction is active
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft}</h3>;
  }
  // timersss  ...

  const handleViewDetails = (id) => {
    localStorage.setItem("selectedPropertyId", id);
    navigate("/purchagdetails");
  };
  return (
    <>
      <Header />
      <div className="property-detail-page scrolleffect">
        {/* Tabs */}
         {/* Tabs */}
        <div className="tabs">
          <div className="btnflx">
            <button
              onClick={() =>
                document
                  .getElementById("Overview")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Overview
            </button>
            <button
              onClick={() =>
                document
                  .getElementById("PropertyDetails")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Property Details
            </button>

            <button
              onClick={() =>
                document
                  .getElementById("RecommendedProperties")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Recommended Properties
            </button>
          </div>
          <Link to="/booktours">
            <button className="booktour">Book a Tour</button>
          </Link>
        </div>

        <div className="main-section" id="Overview">
          {/* Left Gallery */}
          <div className="gallery-section">
            <div className="gallery-grid">
              {/* Left Big Image */}
              <div className="main-photo">
                <img
                  src={mainImage || "https://picsum.photos/800/500?random=1"}
                  alt="Main Property"
                />
                {/* <div className="gallery-buttons">
                  <button>
                    <img src={Gallery} alt="" />
                    Gallery
                  </button>
                  <button>
                    <img src={Map} alt="" />
                    Map View
                  </button>
                  <button>
                    <img src={Street} alt="" />
                    Street View
                  </button>
                </div> */}
              </div>

              {/* Right Thumbnail Grid */}
              <div className="side-thumbnails">
                {thumbImages.slice(0, 4).map((img, index) => (
                  <div
                    key={index}
                    className="thumb-box"
                    onClick={() => handleThumbClick(img)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={img.imageUrl} alt={`Thumbnail ${index + 1}`} />
                    {index === 3 && thumbImages.length > 4 && (
                      <div className="more-overlay">
                        +{thumbImages.length - 4} more
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Property Info */}
        <div className="property-info contianer-fluid">
          <div className="row">
            <div className="col-md-8">
              <h2>{propertyName}</h2>
              <p className="pamp">
                <img src={Map} alt="" />
                {propertyData.unparsedAddress}
                <div className="streetview">
                  <button
                    className="direction"
                    onClick={() => {
                      const lat = propertyData.latitude;
                      const lng = propertyData.longitude;

                      const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

                      window.open(url, "_blank");
                    }}
                  >
                    <img src={Lcoction} alt="" /> Directions
                  </button>
                  <button
                    className="direction"
                    onClick={() => {
                      const lat = propertyData.latitude;
                      const lng = propertyData.longitude;

                      const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`;

                      window.open(url, "_blank");
                    }}
                  >
                    <img src={Lcoction} alt="" /> Street View
                  </button>
                  <ShareDialog listingURL={propertyData?.listingURL} />

                </div>
              </p>
              <h3 className="addressx"><strong style={{ color: "#144788"}}>MLS No:</strong> {propertyData.listingId}</h3>
              <p>
                <strong>Listing Description:</strong> <br></br>{" "}
                {propertyData.publicRemarks}
              </p>
              <div className="property-features" id="PropertyDetails">
                {/* Property Type */}
                {propertyData?.propertyType && (
                  <>
                    <div>
                      <img src={Home} alt="" />
                      <h5>Property Type</h5>
                      <h2>{propertyData.propertyType}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bedrooms */}
                {propertyData?.bedRooms && (
                  <>
                    <div>
                      <img src={BAD} alt="" />
                      <h5>Bedrooms</h5>
                      <h2>{propertyData.bedRooms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bathrooms */}
                {propertyData?.bathroms && (
                  <>
                    <div>
                      <img src={BATH} alt="" />
                      <h5>Bathrooms</h5>
                      <h2>{propertyData.bathroms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Size */}
                {propertyData?.propertySize && (
                  <>
                    <div>
                      <img src={Size} alt="" />
                      <h5>Size</h5>
                      <h2>{propertyData.propertySize} ft²</h2>
                    </div>
                  </>
                )}
              </div>

              {/* <div className="address-details">
                <p>
                  <strong>Address:</strong> {propertyData.unparsedAddress}
                </p>
              </div> */}

              <div className="info-section container">
                <div className="row">
                  <div className="col-md-12" style={{ padding: "0" }}>
                    <div className="info-card bhfg info-cardsh">
                      {/* 1. Property Overview */}
                      <h5>1. Property Overview</h5>
                      <ul className="custom-list">
                        {propertyData?.propertySubType && (
                          <li>
                            Property Type:{" "}
                            <strong>{propertyData.propertySubType}</strong>
                          </li>
                        )}

                        {propertyData?.structureType?.length > 0 && (
                          <li>
                            Building Type:{" "}
                            <strong>
                              {propertyData.structureType.join(", ")}
                            </strong>
                          </li>
                        )}
                        {propertyData?.parcelNumber?.length > 0 && (
                          <li>
                            Parcel Number:{" "}
                            <strong>
                              {propertyData.parcelNumber.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.propertyCondition?.length > 0 && (
                          <li>
                            Property Condition:{" "}
                            <strong>
                              {propertyData.propertyCondition.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.architecturalStyle?.length > 0 && (
                          <li>
                            Architectural Style:{" "}
                            <strong>
                              {propertyData.architecturalStyle.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.stories && (
                          <li>
                            Stories: <strong>{propertyData.stories}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.propertyAttachedYN !== null &&
                          propertyData?.propertyAttachedYN !== undefined && (
                            <li>
                              Property Attached:{" "}
                              <strong>
                                {String(propertyData.propertyAttachedYN)}
                              </strong>
                            </li>
                          )}

                        {propertyData?.yearBuilt && (
                          <li>
                            Year Built:{" "}
                            <strong>{propertyData.yearBuilt}</strong>{" "}
                          </li>
                        )}
                      </ul>

                      {/* 2. Location Details */}
                      <h5>2. Location Details</h5>
                      <ul className="custom-list">
                        {propertyData?.unparsedAddress && (
                          <li>
                            Address:{" "}
                            <strong>{propertyData.unparsedAddress}</strong>
                          </li>
                        )}

                        {propertyData?.streetNumber && (
                          <li>
                            Street Number:{" "}
                            <strong>{propertyData.streetNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.streetName && (
                          <li>
                            Street Name:{" "}
                            <strong> {propertyData.streetName}</strong>
                          </li>
                        )}

                        {propertyData?.unitNumber && (
                          <li>
                            Unit Number:{" "}
                            <strong>{propertyData.unitNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.city && (
                          <li>
                            City: <strong>{propertyData.city}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.stateOrProvince && (
                          <li>
                            Province:{" "}
                            <strong>{propertyData.stateOrProvince}</strong>
                          </li>
                        )}

                        {propertyData?.postalCode && (
                          <li>
                            Postal Code:{" "}
                            <strong> {propertyData.postalCode}</strong>
                          </li>
                        )}
{/* 
                        {propertyData?.country && (
                          <li>
                            Country: <strong>{propertyData.country}</strong>{" "}
                          </li>
                        )} */}

                        {propertyData?.subdivisionName && (
                          <li>
                            Sub DIvision Name:{" "}
                            <strong>{propertyData.subdivisionName}</strong>
                          </li>
                        )}

                        {propertyData?.directions && (
                          <li>
                            Location Direction:{" "}
                            <strong>{propertyData.directions}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.municipality && (
                          <li>
                            Municipality:{" "}
                            <strong>{propertyData.municipality}</strong>{" "}
                          </li>
                        )}
                      </ul>

                      {/* 3. Price & Financial Info */}
                      <h5>3. Price & Financial Info</h5>
                      <ul className="custom-list">
                        {/* {propertyData?.listPrice && (
                          <li>
                            Desired Property Value:{" "}
                            <strong> {propertyData.listPrice}</strong>
                          </li>
                        )} */}

                        {propertyData?.leaseAmount && (
                          <li>
                            Lease Amount:{" "}
                            <strong> {propertyData.leaseAmount}</strong>
                          </li>
                        )}

                        {propertyData?.leaseAmountFrequency && (
                          <li>
                            Lease Amount Frequency:{" "}
                            <strong>{propertyData.leaseAmountFrequency}</strong>
                          </li>
                        )}

                        {propertyData?.businessType && (
                          <li>
                            Business Type:{" "}
                            <strong>{propertyData.businessType}</strong>
                          </li>
                        )}

                        {propertyData?.pricePerUnit && (
                          <li>
                            Price Per Unit:{" "}
                            <strong> {propertyData.pricePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.leasePerUnit && (
                          <li>
                            Lease Per Unit:{" "}
                            <strong> {propertyData.leasePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.taxYear && (
                          <li>
                            Tax Annual Amount:{" "}
                            <strong> {propertyData.taxYear}</strong>
                          </li>
                        )}

                        {propertyData?.taxBlock && (
                          <li>
                            Tax Block: <strong> {propertyData.taxBlock}</strong>
                          </li>
                        )}

                        {propertyData?.totalActualRent && (
                          <li>
                            Actual Rent:{" "}
                            <strong> {propertyData.totalActualRent}</strong>
                          </li>
                        )}

                        {propertyData?.offerStartingPrice && (
                          <li>
                            OfferStarting Price:{" "}
                            <strong>{propertyData.offerStartingPrice}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 4. Home Features & Interior */}
                      <h5>4. Home Features & Interior</h5>
                      <ul className="custom-list">
                        {propertyData?.bedroomsTotal && (
                          <li>
                            Total Number Of Bedroom:{" "}
                            <strong>{propertyData.bedroomsTotal}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.bedroomsAboveGrade && (
                          <li>
                            Bedrooms Counts Above Grade:{" "}
                            <strong>{propertyData.bedroomsAboveGrade}</strong>
                          </li>
                        )}

                        {propertyData?.bedroomsBelowGrade && (
                          <li>
                            Bedrooms Counts Below Grade:{" "}
                            <strong>{propertyData.bedroomsBelowGrade}</strong>
                          </li>
                        )}

                        {propertyData?.zoning && (
                          <li>
                            Zoning: <strong>{propertyData.zoning}</strong>
                          </li>
                        )}

                        {propertyData?.zoningDescription && (
                          <li>
                            Zoning Description:{" "}
                            <strong>{propertyData.zoningDescription}</strong>
                          </li>
                        )}

                        {propertyData?.bathroomsTotalInteger && (
                          <li>
                            Total Number Of Bathrooms:{" "}
                            <strong>
                              {propertyData.bathroomsTotalInteger}
                            </strong>
                          </li>
                        )}

                        {propertyData?.bathroomsPartial && (
                          <li>
                            Total Number of Half Bathrooms:{" "}
                            <strong>{propertyData.bathroomsPartial}</strong>
                          </li>
                        )}

                        {propertyData?.livingArea && (
                          <li>
                            Living Area:{" "}
                            <strong>{propertyData.livingArea}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.livingAreaUnits && (
                          <li>
                            Living Area Units:{" "}
                            <strong> {propertyData.livingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaSource && (
                          <li>
                            Living Area Source:{" "}
                            <strong> {propertyData.livingAreaSource}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMinimum && (
                          <li>
                            Living Area Minimum:{" "}
                            <strong> {propertyData.livingAreaMinimum}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMaximum && (
                          <li>
                            Living Area Maximum:{" "}
                            <strong>{propertyData.livingAreaMaximum}</strong>
                          </li>
                        )}

                        {propertyData?.basement?.length > 0 && (
                          <li>
                            Basement Available:{" "}
                            <strong>{propertyData.basement.join(", ")}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.flooring?.length > 0 && (
                          <li>
                            Flooring Type:{" "}
                            <strong> {propertyData.flooring.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceYN != null && (
                          <li>
                            Fireplace:{" "}
                            <strong>{String(propertyData.fireplaceYN)}</strong>
                          </li>
                        )}

                        {propertyData?.fireplacesTotal && (
                          <li>
                            Fireplace Total:{" "}
                            <strong> {propertyData.fireplacesTotal}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceFeatures?.length > 0 && (
                          <li>
                            Fireplace Features:{" "}
                            <strong>
                              {propertyData.fireplaceFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 5. Building Details */}
                      <h5>5. Building & Construction Details</h5>
                      <ul className="custom-list">
                        {propertyData?.buildingAreaTotal && (
                          <li>
                            Building Area:{" "}
                            <strong> {propertyData.buildingAreaTotal}</strong>
                          </li>
                        )}

                        {propertyData?.buildingAreaUnits && (
                          <li>
                            Building Area Units:{" "}
                            <strong> {propertyData.buildingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.buildingFeatures?.length > 0 && (
                          <li>
                            Building Features:{" "}
                            <strong>
                              {propertyData.buildingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.constructionMaterials?.length > 0 && (
                          <li>
                            Construction Materials:{" "}
                            <strong>
                              {propertyData.constructionMaterials.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.foundationDetails?.length > 0 && (
                          <li>
                            Foundation Details:{" "}
                            <strong>
                              {propertyData.foundationDetails.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.exteriorFeatures?.length > 0 && (
                          <li>
                            Exterior Features:{" "}
                            <strong>
                              {propertyData.exteriorFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.roof?.length > 0 && (
                          <li>
                            Roof:{" "}
                            <strong> {propertyData.roof.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.accessibilityFeatures?.length > 0 && (
                          <li>
                            Accessibility Features:{" "}
                            <strong>
                              {propertyData.accessibilityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 6. Lot & Land */}
                      <h5>6. Lot & Land Information</h5>
                      <ul className="custom-list">
                        {propertyData?.lotSizeArea && (
                          <li>
                            Lot Size Area:{" "}
                            <strong>{propertyData.lotSizeArea}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeDimensions && (
                          <li>
                            Lot Size Dimensions:{" "}
                            <strong>{propertyData.lotSizeDimensions}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeUnits && (
                          <li>
                            Lot Size Units:{" "}
                            <strong> {propertyData.lotSizeUnits}</strong>
                          </li>
                        )}

                        {propertyData?.poolFeatures && (
                          <li>
                            Pool Features:{" "}
                            <strong> {propertyData.poolFeatures}</strong>
                          </li>
                        )}

                        {propertyData?.lotFeatures?.length > 0 && (
                          <li>
                            Lot Features:{" "}
                            <strong>
                              {" "}
                              {propertyData.lotFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.fencing?.length > 0 && (
                          <li>
                            Fencing Available:{" "}
                            <strong> {propertyData.fencing.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumeric && (
                          <li>
                            Frontage(Front Length):{" "}
                            <strong>
                              {propertyData.frontageLengthNumeric}
                            </strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumericUnits && (
                          <li>
                            Frontage(Front Length) Unit:{" "}
                            <strong>
                              {propertyData.frontageLengthNumericUnits}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterfrontFeatures?.length > 0 && (
                          <li>
                            Waterfront Features:{" "}
                            <strong>
                              {propertyData.waterfrontFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterBodyName && (
                          <li>
                            Water Body Name:{" "}
                            <strong> {propertyData.waterBodyName}</strong>
                          </li>
                        )}
                        {propertyData?.numberOfBuildings && (
                          <li>
                            Number Of Buildings:{" "}
                            <strong> {propertyData.numberOfBuildings}</strong>
                          </li>
                        )}
                        {propertyData?.numberOfUnitsTotal && (
                          <li>
                            Number Of Units Total:{" "}
                            <strong> {propertyData.numberOfUnitsTotal}</strong>
                          </li>
                        )}

                        {propertyData?.roadSurfaceType?.length > 0 && (
                          <li>
                            Road Surface Type:{" "}
                            <strong>
                              {propertyData.roaddSurfaceType?.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.irrigationSource?.length > 0 && (
                          <li>
                            Irrigation Source:{" "}
                            <strong>
                              {propertyData.irrigationSource.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 7. Utilities */}
                      <h5>7. Utilities & Systems</h5>
                      <ul className="custom-list">
                        {propertyData?.waterSource?.length > 0 && (
                          <li>
                            Water Source:{" "}
                            <strong>
                              {propertyData.waterSource.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.sewer?.length > 0 && (
                          <li>
                            Sewerage Type:{" "}
                            <strong> {propertyData.sewer.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.electric?.length > 0 && (
                          <li>
                            Electric Type:{" "}
                            <strong> {propertyData.electric.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.heating?.length > 0 && (
                          <li>
                            Heating:{" "}
                            <strong> {propertyData.heating.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.cooling?.length > 0 && (
                          <li>
                            Cooling:{" "}
                            <strong> {propertyData.cooling.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.utilities?.length > 0 && (
                          <li>
                            Utilities Available:{" "}
                            <strong>{propertyData.utilities.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.otherEquipment?.length > 0 && (
                          <li>
                            Other Equipment:{" "}
                            <strong>
                              {propertyData.otherEquipment.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.securityFeatures?.length > 0 && (
                          <li>
                            Security Features:{" "}
                            <strong>
                              {propertyData.securityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 8. Community */}
                      <h5>8. Community & Neighborhood</h5>
                      <ul className="custom-list">
                        {propertyData?.communityFeatures?.length > 0 && (
                          <li>
                            Community Features:{" "}
                            <strong>
                              {propertyData.communityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.possibleUse?.length > 0 && (
                          <li>
                            Possible Use:{" "}
                            <strong>
                              {propertyData.possibleUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.currentUse?.length > 0 && (
                          <li>
                            Current Use:{" "}
                            <strong>
                              {" "}
                              {propertyData.currentUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.anchorsCoTenants && (
                          <li>
                            Anchors Co Tenants:{" "}
                            <strong> {propertyData.anchorsCoTenants}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 9. Parking */}
                      <h5>9. Parking & Garage</h5>
                      <ul className="custom-list">
                        {propertyData?.parkingFeatures?.length > 0 && (
                          <li>
                            Parking:{" "}
                            <strong>
                              {propertyData.parkingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.parkingTotal && (
                          <li>
                            Total Parking Available:{" "}
                            <strong>{propertyData.parkingTotal}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 10. HOA */}
                      <h5>10. Association (HOA) Details</h5>
                      <ul className="custom-list">
                        {propertyData?.associationFee && (
                          <li>
                            Association Fee:{" "}
                            <strong> {propertyData.associationFee}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeFrequency && (
                          <li>
                            Association Fee Frequency:{" "}
                            <strong>
                              {propertyData.associationFeeFrequency}
                            </strong>
                          </li>
                        )}

                        {propertyData?.associationName && (
                          <li>
                            AssociationName:{" "}
                            <strong> {propertyData.associationName}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeIncludes?.length > 0 && (
                          <li>
                            Association Fee Includes:{" "}
                            <strong>
                              {propertyData.associationFeeIncludes.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <Slider />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Mylistingview;
